import type { DreamRenderElementProps } from '@/types';
import { dateFormatter } from '@/utils/dateFormatter';

import { StarRating } from '../../shared/starRatingElement/StarRating';

interface Props {
  review?: string | null;
  score: number;
  timestamp: string;
  translations: DreamRenderElementProps<any>['translations'];
}
const OrderItemReview = ({ review, score, translations, timestamp }: Props) => {
  return (
    <div className="flex flex-col bg-gray-50 p-3 gap-2 rounded-lg">
      <div className="flex justify-between items-center">
        <div className="flex flex-row items-center gap-2">
          <h5 className="text-gray-900 text-sm font-medium w-full sm:w-auto break-words">
            {translations?.['manage.orders.order.review.title'] || 'Review'}
          </h5>
          <StarRating disabled value={score} size={16} />
        </div>
        <span className="text-gray-500 text-sm font-normal leading-5 w-full sm:w-auto break-words">
          {dateFormatter({}).format(new Date(timestamp))}
        </span>
      </div>
      {review && (
        <p className="text-gray-500 text-sm font-normal leading-5 w-full sm:w-auto break-words italic">"{review}"</p>
      )}
    </div>
  );
};

export default OrderItemReview;
